import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "components/Typography";
import Div from "components/primitives/Div";
import type { UpsellFeatureCardContent } from "../../Upsell.types";

const Root = styled(Div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
  padding: "25px",
  minHeight: "180px",
  borderRadius: "10px",
  border: `1px solid ${theme.palette.grey[20]}`,
  backgroundColor: theme.palette.common.white,
}));

const IconTile = styled(Div)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "40px",
  height: "40px",
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.secondary1[10],
  marginBottom: theme.spacing(0.5),

  ".MuiSvgIcon-root": {
    color: theme.palette.secondary1[180],
    fontSize: "20px",
  },
}));

const Title = styled(Typography)({
  fontWeight: 600,
});

const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[120],
}));

interface UpsellFeatureCardProps {
  card: UpsellFeatureCardContent;
}

function UpsellFeatureCard(props: UpsellFeatureCardProps) {
  const { card } = props;

  const { t } = useTranslation();

  const Icon = card.icon;

  return (
    <Root>
      <IconTile>
        <Icon />
      </IconTile>
      <Title variant="TextM">{t(card.title)}</Title>
      <Description variant="TextS">{t(card.description)}</Description>
    </Root>
  );
}

export default UpsellFeatureCard;
